import DayPicker from "web/components/DayPicker/DayPicker"
import RangeDayPicker from "web/components/DayPicker/RangeDayPicker"
export default function DayPickerWrapper({
  isRangeDayPicker,
  value,
  label,
  onChange,
}) {
  const Component = isRangeDayPicker ? RangeDayPicker : DayPicker
  return (
    <div className="flex flex-grow flex-col space-y-5 md:flex-row md:space-x-3 md:space-y-0">
      <div className="flex flex-col md:min-w-xs">
        <div className="mx-6 border-b-2 border-blue-600">{label}</div>
        <Component value={value} onChange={onChange} />
      </div>
    </div>
  )
}
